import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/planificadorTarea/importer/planificadorTareaImporterActions';

export default importerReducers(actions);
